import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

declare var window: any;

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
})
export class DatetimePickerComponent implements OnInit, OnChanges {

  /**
   * Option if input field needs to cleared after successful selection
   */
  @Input() clearInputAfterSelection: boolean = false;

  /**
   * Date string separator
   */
  @Input() dateStrSeparator: string = '-';

  /**
   * Date time input for default value
   */
  @Input() datetime: any;

  @Input() hideExtraLine: boolean = false;

  /**
   * 12 hour or 24 hour format
   */
  @Input() meridian: boolean = true;

  /**
   * Minimum minute step
   */
  @Input() minuteStep: number = 5;

  /**
   * Enable for only time picker
   */
  @Input() showDatePicker: boolean = true;

  /**
   * Enable for only time picker
   */
  @Input() showTimePicker: boolean = true;

  /**
   * Indicates if input fields are to be of small size
   */
  @Input() small: boolean = false;

  /**
   * Indicates if time picker is editable
   */
  @Input() timePickerEditable: boolean = true;

  /**
   * Date string for input value
   * @type {string}
   */
  @Input() dateStr: string;

  /**
   * Date struct for date with keys - year, month and day
   * @type {any}
   */
  dateStruct: any;

  /**
   * Min date for datepicker (100 years ago)
   */
  minDate: any;

  /**
   * Max date for datepicker (current year + 10)
   */
  maxDate: any;

  /**
   * Time struct for time with keys - hour, minute, second
   * @type {any}
   */
  timeStruct: any;

  /**
   * Result in ISO8601 string format
   * @param {EventEmitter<string> = new EventEmitter(} ) result
   */
  @Output() result: EventEmitter<string> = new EventEmitter();

  /**
   * Result as struct (object with keys)
   * @param {EventEmitter<any> = new EventEmitter(} ) ngbResult
   */
  @Output() ngbResult: EventEmitter<any> = new EventEmitter();

  /**
   * Result as date string
   * @param {EventEmitter<string> = new EventEmitter(} ) dateStrResult
   */
  @Output() dateStrResult: EventEmitter<string> = new EventEmitter();

  /**
   * Constructor function
   */
  constructor() {}

  // Component lifecycle methods

  /**
   * Called on component initialization
   */
  ngOnInit() {
    const now = new Date();
    this.minDate = { year: now.getFullYear() - 100, month: 1, day: 1 };
    this.maxDate = { year: now.getFullYear() + 10, month: 12, day: 31 };

    if (this.datetime) {
      this.dateStruct = this.datetime;
      this.timeStruct = this.datetime;
      this.setDateStr();
    }
  }

  /**
   * Called when instance variables change
   * @param {SimpleChanges} changes Angular object containing changes to instance variables
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.datetime && changes.datetime.currentValue) {
      this.dateStruct = this.datetime;
      this.timeStruct = this.datetime;
      this.setDateStr();
    } else if (changes.datetime && !changes.datetime.currentValue) {
      this.dateStruct = {};
      this.timeStruct = {};
      this.setDateStr();
    }
  }

  // Component methods

  /**
   * Date changed
   */
  dateChange() {
    if (!this.dateStr || this.dateStr.trim() === '') {
      this.dateStruct = {};
      this.triggerOutput();
      return;
    }
    if (String(this.dateStr).length == 10) {
      this.dateStruct = {
        month: Number(this.dateStr.substring(0, 2)),
        day: Number(this.dateStr.substring(3, 5)),
        year: Number(this.dateStr.substring(6, 10))
      };
      this.triggerOutput();
    }
  }

  /**
   * Set date using moment date object
   * @param {any} date moment date object
   */
  setDate(momentDate: any) {
    this.dateStruct = {
      day: momentDate.date(),
      month: momentDate.month() + 1,
      year: momentDate.year(),
    };
    this.timeStruct = {
      hour: momentDate.hour(),
      minute: momentDate.minute(),
      second: momentDate.second(),
    };
    console.log(momentDate, this.dateStruct);
    this.setDateStr();
    this.triggerOutput();
  }

  /**
   * Set date string for input value
   */
  setDateStr() {
    this.dateStr = '';
    if (this.dateStruct && this.dateStruct.year) {
      if (this.dateStruct.month < 10) this.dateStr += `0${this.dateStruct.month}`;
      else this.dateStr += `${this.dateStruct.month}`;
      if (this.dateStruct.day < 10) this.dateStr += `${this.dateStrSeparator}0${this.dateStruct.day}`;
      else this.dateStr += `${this.dateStrSeparator}${this.dateStruct.day}`;
      this.dateStr += `${this.dateStrSeparator}${this.dateStruct.year}`;
    }
  }

  /**
   * Emit event for Angular output
   */
  triggerOutput() {
    let result: any = {};
    let resultStr: string = '';
    if (this.showDatePicker && this.dateStruct) {
      result.year = this.dateStruct.year;
      result.month = this.dateStruct.month;
      result.day = this.dateStruct.day;
      resultStr += `${result.year}`;
      if (result.month < 10) resultStr += `-0${result.month}`;
      else resultStr += `-${result.month}`;
      if (result.day < 10) resultStr += `-0${result.day}`;
      else resultStr += `-${result.day}`;
    }
    if (this.showTimePicker && this.timeStruct) {
      result.hour = this.timeStruct.hour;
      result.minute = this.timeStruct.minute;
      result.second = this.timeStruct.second;
      if (result.hour < 10) resultStr += `T0${result.hour}`;
      else resultStr += `T${result.hour}`;
      if (this.dateStruct.minute < 10) resultStr += `:0${result.minute}`;
      else resultStr += `:${result.minute}`;
      if (this.dateStruct.second < 10) resultStr += `:0${result.second}`;
      else resultStr += `:${result.second}`;
    }
    this.ngbResult.emit(result);
    this.result.emit(resultStr);
    this.setDateStr();
    this.dateStrResult.emit(this.dateStr);
  }
}
